import { render, staticRenderFns } from "./Version.vue?vue&type=template&id=3ccbd84c"
import script from "./Version.vue?vue&type=script&lang=ts"
export * from "./Version.vue?vue&type=script&lang=ts"
import style0 from "./Version.vue?vue&type=style&index=0&id=3ccbd84c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports